import { FC } from 'react';
import AchLogo from 'assets/images/payment-logos/ach.png';
import AmexLogo from 'assets/images/payment-logos/amex.png';
import ApplePayLogo from 'assets/images/payment-logos/apple-pay.png';
import GooglePayLogo from 'assets/images/payment-logos/google-pay.png';
import LinkLogo from 'assets/images/payment-logos/link.png';
import MastercardLogo from 'assets/images/payment-logos/mastercard.png';
import VisaLogo from 'assets/images/payment-logos/visa.png';

export const PaymentLogos: FC = () => (
  <div className="payment-logos">
    <span className="payment-logos-label">We accept</span>
    <div className="payment-logos-icons">
      <img src={VisaLogo} alt="Visa" className="payment-logo payment-logo-desktop-only" />
      <img
        src={MastercardLogo}
        alt="Mastercard"
        className="payment-logo payment-logo-desktop-only"
      />
      <img
        src={AmexLogo}
        alt="American Express"
        className="payment-logo payment-logo-desktop-only"
      />
      <img src={ApplePayLogo} alt="Apple Pay" className="payment-logo" />
      <img src={GooglePayLogo} alt="Google Pay" className="payment-logo" />
      <img src={LinkLogo} alt="Link" className="payment-logo" />
      <img src={AchLogo} alt="ACH" className="payment-logo payment-logo-desktop-only" />
    </div>
  </div>
);
